import { routeToSpecificScope } from '../../helpers/helpersts';
import { catchError, requestIsOk, valid } from '../../helpers/services';
import { OPTIONS, SERVER } from '../server.config';
import store from '../../store';

export const requestData = (url: string, options?: RequestInit) => {
  const path = store.getState().router.location.pathname;
  const scope = routeToSpecificScope(path);
  // OPTIONS.headers.id_token = store.getState().user.tokenId;
  return fetch(url, options ? options : {}) //, OPTIONS)
    .then(response => requestIsOk(response, scope))
    .then(data => valid(data, scope))
    .catch((err) => {
      catchError(err, options && options.signal);
    });
};

export const requestAsJson = async (url: string, options: { method: string, headers: Headers, body?: string }) => {
  const response = await fetch(url, options ? options : {});
  if (response.ok) {
    return response.json();
  } else {
    return response.statusText;
  }
};

export const request = (url: string, signal: AbortSignal) => {
  const path = store.getState().router.location.pathname;
  const scope = routeToSpecificScope(path);
  // OPTIONS.headers.id_token = store.getState().user.tokenId;
  return fetch(url, signal ? { signal: signal } : {}) //, OPTIONS)
    .then(response => requestIsOk(response, scope))
    .catch((err) => {
      catchError(err, signal);
    });
};

export const requestDataWithOptions = (url: string, tokenId: string) => {
  OPTIONS.headers.id_token = tokenId;
  const path = store.getState().router.location.pathname;
  const scope = routeToSpecificScope(path);
  return fetch(url, OPTIONS)
    .then(response => requestIsOk(response, scope))
    .then(data => valid(data))
    .catch((err) => catchError(err));
};

export const logout = () => {
  return fetch(SERVER.LOGOUT)
    .then(res => {
      return res.text();
    })
    .then(function (myJson) {
    })
    .catch(function (err) {
      console.error('Fetch Error Logout :', err);
      return null;
    });
};

export const putData = (url: string, body: any) => {
  // OPTIONS.headers.id_token = store.getState().user.tokenId;
  return fetch(url, {
    method: 'PUT',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(body)
  }) //, OPTIONS)
    .then(response => response.json())
    .then(data => console.info(data)) // TODO: console.info is needed ?
    .catch((err) => {
      console.error(err);
    });
};


export const checkPdf = async (urlRequest: string) => {
  const pdf = await fetch(urlRequest)
              .then((response)=>response.json());
  return pdf.code;
};

export const requestPdf = (urlRequest: string, fileName: string, onSuccess: () => void, onFailure: () => void) => {
  fetch(urlRequest, { method: 'GET' })
    .then(response => {
      if (response.status !== 200) {
        throw Error(response.statusText);
      }
      return response.text();
    })
    .then(data => {
      const byteString = window.atob(data);
      // Convert that text into a byte array.
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ia], {
        type: 'application/octet-stream;'
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.href = url;
      a.target = '_blank';
      a.download = `${fileName}.pdf`;
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 1000);
      onSuccess();
    })
    .catch((err) => {
      onFailure();
    });
};